export default "__VITE_ASSET__TT4ZuFwI__"